module.exports = __webpack_public_path__ + "img/icon_trade_bainjie.7b25faf2.png";